module.exports = __webpack_public_path__ + "static/media/Gender-UC.9a9cce81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Gender-UC.svg
// module id = 366
// module chunks = 0